var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 124,
    viewBox: "0 0 140 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5926_4854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2657 26.5917C42.4089 25.1804 43.9554 24.105 45.6027 23.3657C44.0563 22.5929 42.2744 22.0889 40.5597 21.4838C38.7779 20.2406 38.7779 18.1906 40.2234 16.5104C41.6017 15.5023 43.1482 14.4941 44.7283 13.4862C49.9394 11.7724 58.7813 17.4178 62.3448 24.6762C63.3535 25.3146 64.2949 26.0538 65.169 26.8939C67.3205 24.9784 70.0102 23.8361 73.0022 24.1047C75.0196 24.2728 76.8684 25.0793 78.4485 26.3224C87.5258 27.0953 94.6531 32.1023 99.4607 39.7641C102.957 45.3759 105.546 53.2391 105.411 59.9263C105.109 78.5091 96.8383 93.8996 77.7762 98.8394C73.0695 100.049 65.875 101.796 61.0335 100.385C56.9992 101.796 55.2173 101.628 50.8802 100.587C38.2391 101.595 25.5311 99.0747 16.2183 89.9008C8.78928 82.5418 5.05733 72.3264 4.62042 61.9763C4.31773 54.2809 5.8642 46.216 9.69704 39.4619C12.8236 33.9509 17.7657 29.0111 24.187 27.7004C25.3302 27.4651 26.5403 27.3306 27.7171 27.3642C32.3566 24.9112 36.4581 24.8776 41.2657 26.5914V26.5917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0008 98.5378C57.101 99.949 55.8569 99.9827 51.0493 98.8067C20.2539 101.394 7.20951 81.3662 6.40264 61.9094C5.62941 43.6963 15.816 28.6417 28.1208 29.1123C32.6256 26.6593 36.5257 26.5248 41.9384 28.7426C45.67 22.1226 59.3871 21.8873 65.0687 29.4818C68.9013 25.0124 74.0115 24.7774 77.7432 28.0369C96.9065 29.3137 103.832 49.9465 103.664 59.8933C103.428 73.1333 98.789 91.548 77.3396 97.1262C71.8261 98.5375 65.0684 99.9824 61.0005 98.5375L61.0008 98.5378Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0008 98.5377C57.101 99.949 55.8569 99.9826 51.0493 98.8066C20.2539 101.394 7.20951 81.3661 6.40264 61.9093C5.62941 43.6963 15.816 28.6416 28.1208 29.1122C31.281 28.373 37.8368 28.3394 42.8798 30.4899C50.1752 25.2812 57.4034 26.0877 64.9006 30.2546C68.2289 27.3984 73.877 25.3821 77.3735 29.2464C74.3142 28.9439 70.6832 29.5826 67.8593 30.9602C63.9931 31.2964 59.8915 31.6659 57.0337 34.119C53.369 32.3379 51.1502 32.7749 46.9477 34.5223C44.7289 33.0102 42.7789 30.8261 37.3662 32.6741C21.1953 28.608 14.404 48.5016 16.5892 65.068C18.0684 76.2916 26.4398 89.229 34.1051 94.6394C37.1644 95.1433 36.5257 83.315 37.8032 80.2235C41.3669 86.3059 48.8638 94.2363 55.6551 94.6394C60.5636 94.9756 64.7997 89.666 68.5649 84.9279C68.834 93.2617 76.1967 94.9756 86.0809 88.1203C84.1981 91.5143 89.1738 91.1109 91.0566 90.338C87.4928 93.2951 83.0216 95.6473 77.3399 97.1261C71.8263 98.5374 65.0687 99.9823 61.0008 98.5374V98.5377Z",
    fill: "#CC3300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7007 29.7508C32.9618 30.759 35.8866 31.8341 37.2988 32.9767C39.9548 32.3719 43.2159 31.8005 46.8467 34.9259C50.1414 33.1448 52.9989 33.1448 56.7645 36.5052C58.9496 33.6154 61.942 30.8598 67.8588 31.5654C69.1026 30.8598 70.6494 30.3892 72.9354 30.4564C74.2465 29.4482 76.1293 29.2465 78.1802 29.3138C74.5155 29.1121 74.2131 28.0369 66.985 30.8931C65.6067 31.1284 63.892 31.3971 62.0765 31.6996C60.4961 18.0902 49.2336 13.7216 46.0398 14.4611C45.3338 14.6292 44.157 15.5029 42.9469 16.343C41.8709 17.1495 40.6272 17.8888 41.0304 19.6026C41.4004 21.0811 47.2499 21.8204 49.5363 24.0384C52.4275 26.794 52.4947 33.2796 46.8803 34.0188C43.6528 31.7002 37.5003 30.3895 29.7007 29.7511V29.7508Z",
    fill: "#043018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0488 98.806C46.9809 97.1258 43.0474 91.7157 40.2905 84.894C42.2069 90.7075 43.3162 95.5801 48.7291 98.9741C49.0655 98.9405 49.4687 99.1086 49.8051 99.1086C50.242 99.075 50.5783 98.8396 51.0488 98.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4088 99.1759C36.8617 97.0253 25.8679 88.4562 23.1113 81.6682C25.0277 87.4816 32.861 95.0762 39.2823 98.7725C39.6522 98.8061 40.19 99.31 40.5597 99.3773C40.8624 99.4109 42.0053 99.1419 42.4088 99.1756V99.1759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9667 98.8733C60.2944 99.1086 59.3866 99.1086 58.6807 99.2764C61.8745 97.7642 67.052 95.1767 68.5985 83.7514C68.3631 93.2612 65.4383 97.0922 61.9418 98.806C61.5718 98.7388 61.2694 98.9741 60.9667 98.8733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4173 72.3935C91.7284 83.0795 83.8952 93.5975 76.667 97.2938C82.1133 92.9588 89.1399 83.8857 90.4173 72.3935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4221 67.7898C14.6395 53.4411 24.49 33.9507 36.8284 33.1778C24.6918 36.1012 17.5645 55.0202 20.4221 67.7898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4365 55.4907C10.6383 44.099 20.5561 30.8591 28.3894 29.7837C21.7326 32.1023 12.7899 44.0987 10.4365 55.4907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2911 46.6869C87.5265 39.6975 81.1052 33.3798 76.2974 31.9685C80.0626 34.4552 85.778 39.2941 87.2911 46.6869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3877 51.1229C63.6904 45.1077 61.5722 39.395 56.7646 36.5052C60.3621 40.7394 62.5136 44.671 63.3877 51.1229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2392 30.4893C92.1321 31.8334 98.1498 43.2923 99.7971 49.7106C102.184 58.9853 99.1921 76.2241 95.6955 76.3247C93.6113 76.3919 92.7371 66.9827 90.0139 60.1277C91.2913 76.9631 81.6761 89.9341 76.2299 88.4892C70.4136 86.9771 74.6498 73.3676 73.5738 62.6816C72.3634 51.1555 69.1023 44.0316 63.1518 36.4034C59.4538 31.6317 68.4639 31.8334 72.9351 37.2435C71.6577 34.4206 70.9515 32.6399 72.0946 31.8334C76.2971 31.9679 84.0295 37.6805 89.5433 54.1464C89.3415 43.5948 87.0218 35.2947 81.2392 30.4893Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1669 36.7402C55.9575 36.7402 61.7398 48.2327 61.7398 58.3475C61.7398 68.4624 58.0417 85.3314 55.2512 85.3314C52.4606 85.3314 46.4766 68.2607 46.4766 58.1459C46.4766 48.031 50.3764 36.7402 53.1669 36.7402Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5248 36.8076C29.7006 38.8909 25.0948 46.956 26.7422 48.7704C28.4232 50.5851 33.5671 44.0996 36.391 42.0496C39.1815 39.9663 41.1313 37.8491 39.8875 36.1352C38.6101 34.455 35.3153 34.7576 32.5248 36.8073V36.8076Z",
    fill: "#FF9933"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5926_4854)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8876 64.6247C97.7895 64.0741 98.847 63.7862 99.8942 63.7023C99.1972 62.977 98.3187 62.3532 97.4969 61.6871C96.7626 60.6581 97.1624 59.5344 98.2825 58.8953C99.2347 58.6115 100.279 58.3605 101.342 58.1162C104.532 58.1931 108.278 63.0122 108.816 67.6859C109.244 68.2326 109.616 68.8214 109.931 69.4524C111.484 68.8221 113.181 68.7205 114.769 69.4513C115.842 69.9369 116.698 70.7395 117.322 71.7292C122.147 73.9233 125.077 78.058 126.218 83.1955C127.04 86.9535 126.926 91.7687 125.548 95.4081C121.758 105.535 114.222 112.359 102.81 111.348C99.9939 111.094 95.7095 110.648 93.3308 108.93C90.8442 108.917 89.9002 108.477 87.726 107.061C80.6001 105.148 74.1257 101.288 70.8101 94.4426C68.1731 88.9598 68.1198 82.6324 69.899 76.8737C71.234 72.5964 73.6547 68.4772 77.073 65.5224C79.8616 63.1114 83.5341 61.3675 87.3096 61.9014C87.9821 61.9954 88.6717 62.1577 89.3102 62.4057C92.3318 61.9659 94.5867 62.7474 96.8877 64.6245L96.8876 64.6247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6729 107.911C91.26 107.924 90.5715 107.7 88.1656 106.118C70.7803 101.53 67.5362 88.0073 70.8887 77.1845C74.0171 67.0502 82.5371 60.7847 89.1903 63.4426C92.1381 62.9765 94.3021 63.6635 96.8366 65.9349C100.173 63.0339 107.738 65.5803 109.371 70.8514C112.344 69.1489 115.191 70.0168 116.601 72.5314C126.856 76.9688 126.628 89.6295 124.596 95.0491C121.885 102.261 115.75 111.45 102.904 110.324C99.6069 110.022 95.6209 109.496 93.6728 107.911L93.6729 107.911Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6732 107.911C91.2603 107.924 90.5717 107.7 88.1658 106.118C70.7806 101.53 67.5364 88.0072 70.889 77.1845C74.0174 67.0502 82.5374 60.7847 89.1905 63.4426C91.067 63.6537 94.6671 64.9139 97.012 67.0763C102.027 65.644 105.832 67.4959 109.129 71.2422C111.51 70.3257 114.999 70.3221 116.162 73.1223C114.544 72.3598 112.43 72.0017 110.613 72.2061C108.428 71.6363 106.108 71.0389 104.063 71.8261C102.401 70.1351 101.1 69.9419 98.4554 70.0801C97.5341 68.8185 96.8912 67.2409 93.5638 67.1982C85.4926 61.8154 77.89 71.3956 75.8567 80.9027C74.4785 87.3435 76.544 96.0679 79.6906 100.529C81.2692 101.402 83.2261 94.7933 84.5293 93.3478C85.2965 97.377 87.8592 103.186 91.5033 104.732C94.1283 105.873 97.4859 103.789 100.474 101.926C98.996 106.547 102.698 108.922 109.453 107.092C107.759 108.586 110.565 109.335 111.748 109.279C109.217 110.204 106.308 110.622 102.905 110.324C99.6073 110.022 95.6213 109.496 93.6733 107.911L93.6732 107.911Z",
    fill: "#CC3300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9318 64.1007C91.5227 65.2894 92.9162 66.4492 93.4675 67.351C95.0414 67.5375 96.9404 67.8603 98.3211 70.2816C100.474 69.9479 102.041 70.5052 103.45 73.0817C105.211 71.9238 107.389 70.9969 110.494 72.5377C111.314 72.3935 112.253 72.4372 113.493 72.92C114.409 72.623 115.48 72.8797 116.591 73.3165C114.622 72.4912 114.666 71.8429 110.146 71.9988C109.345 71.8589 108.353 71.6718 107.299 71.4835C109.087 63.7152 103.765 59.1239 101.87 58.9064C101.45 58.8608 100.635 59.1103 99.8077 59.3347C99.0607 59.567 98.2347 59.7296 98.1215 60.7477C98.0359 61.6303 101.098 63.1764 101.919 64.8382C102.966 66.9126 101.738 70.4808 98.5164 69.791C97.1995 67.8905 94.0826 65.9721 89.9317 64.1009L89.9318 64.1007Z",
    fill: "#043018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.1658 106.117C86.2636 104.403 85.1627 100.67 84.9819 96.3932C84.8986 99.9537 84.5563 102.841 86.8614 105.757C87.0523 105.804 87.2406 105.975 87.425 106.041C87.671 106.107 87.9013 106.044 88.1658 106.117Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3577 104.635C80.7364 102.374 76.3815 95.5328 76.1943 91.2743C76.111 94.8348 78.9236 100.526 81.7225 103.804C81.9187 103.895 82.1153 104.276 82.3048 104.385C82.4641 104.462 83.1431 104.538 83.3577 104.635L83.3577 104.635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5889 108.089C93.1745 108.086 92.6769 107.909 92.2572 107.864C94.3028 107.658 97.6456 107.249 100.722 101.288C98.7378 106.455 96.3874 107.984 94.1365 108.242C93.9468 108.133 93.7352 108.203 93.5889 108.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.897 99.3176C113.532 105.431 107.186 109.669 102.503 110.285C106.334 108.971 111.956 105.368 114.897 99.3176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4267 83.1423C77.0555 74.1491 86.2565 65.3866 93.1706 67.3694C85.9477 66.6048 78.3509 75.5852 77.4267 83.1423Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3519 74.4529C76.6843 68.2479 84.7031 62.9247 89.2066 63.863C85.1055 63.8356 77.8637 68.6674 74.3519 74.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.197 84.6167C119.689 80.8313 117.402 76.1158 115.042 74.4045C116.62 76.502 118.81 80.2692 118.197 84.6167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.229 82.3862C105.568 79.148 105.521 75.6034 103.45 73.0817C104.596 76.1043 105.008 78.6791 104.229 82.3862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.039 74.5576C123.748 77.4189 124.812 84.8738 124.463 88.7133C123.962 94.2628 118.96 103.129 117.024 102.502C115.868 102.132 117.224 96.8041 117.068 92.5154C114.485 101.993 106.685 107.228 103.981 105.373C101.088 103.41 106.064 96.7763 107.559 90.7089C109.143 84.1547 108.745 79.6136 106.971 74.2717C105.875 70.9348 110.774 72.8027 112.17 76.6403C112.02 74.8438 111.98 73.7299 112.764 73.5108C115.042 74.4042 118.166 79.0437 117.977 89.1449C119.924 83.3217 120.272 78.3195 118.039 74.5576Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.432 72.5088C102.962 73.0531 103.89 80.4805 101.917 86.025C99.9442 91.5695 94.627 100.095 93.0973 99.5508C91.5677 99.0065 91.6169 88.482 93.5897 82.9376C95.5625 77.3931 99.9023 71.9646 101.432 72.5088Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1037 68.5197C88.1493 69.1109 84.0516 72.6335 84.6007 73.9494C85.1682 75.2719 89.2528 72.7201 91.2005 72.1472C93.1365 71.5495 94.6182 70.7692 94.2707 69.5872C93.8982 68.417 92.0331 67.9403 90.1037 68.5196L90.1037 68.5197Z",
    fill: "#FF9933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5926_4854",
    x: 0,
    y: 0,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.138158 0 0 0 0 0.142105 0 0 0 0 0.161842 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5926_4854"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5926_4854",
    x: 58,
    y: 42,
    width: 81.751,
    height: 81.7511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.138158 0 0 0 0 0.142105 0 0 0 0 0.161842 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5926_4854"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkin);
export default __webpack_public_path__ + "static/media/pumpkin.7018b5729f8726c7b7684e3695910f17.svg";
export { ForwardRef as ReactComponent };